import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooDiscountCode } from '@/utils/articleContent';

export default function SugargooDiscountCodePage() {
  return <ArticleLayout article={sugargooDiscountCode} />;
}